import React from 'react';
import { Card } from '@cvent/carina/components/Card';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';

type CardContainerProps = {
  testID: string;
  children?: React.ReactNode;
};
export const CardContainer = ({ testID, children }: CardContainerProps): JSX.Element => {
  const cardCol = {
    s: { width: 382 },
    m: { width: 456 },
    l: { width: 456 },
    xl: { width: 456 }
  };
  return (
    <Row role={'main'} minHeight={300} justifyContent={'center'} testID={`${testID}_card__row`}>
      <Col {...cardCol} testID={`${testID}_card__col`} padding={0}>
        <Card bodyContent={children} orientation={'vertical'} elevation={2} height={'100%'} width={'100%'} />
      </Col>
    </Row>
  );
};
